import { EnumHelperBase, type EnumDataObject } from './enum.helpers';

export enum EVENT_CATEGORY {
	MUSIC = 1,
	FOOD = 2,
	CULTURE = 3,
	WINE = 4,
	SPORT = 5,
	SERIES = 6,
	FESTIVAL = 7,
	CHILDREN = 8,
	PARTY = 9,
	THEATER = 10,
	CONCERT = 11,
	BEER = 12,
}

export interface EventCategoryEnumBaseData extends EnumDataObject<EventCategoryEnumBaseExtraData, EVENT_CATEGORY, 'eventCategoryId'> {}

export interface EventCategoryEnumBaseExtraData {}

/**
 * Base Event Category enumeration
 * @see https://github.com/NFCtron/nfctron-db/blob/dev/diagrams/event-settings.png
 */
export class EventCategoryEnumBase extends EnumHelperBase<EventCategoryEnumBaseExtraData, EVENT_CATEGORY, 'eventCategory', 'eventCategoryId'> {
	constructor() {
		super(
			'eventCategory',
			{
				[EVENT_CATEGORY.MUSIC]: {},
				[EVENT_CATEGORY.FOOD]: {},
				[EVENT_CATEGORY.CULTURE]: {},
				[EVENT_CATEGORY.WINE]: {},
				[EVENT_CATEGORY.SPORT]: {},
				[EVENT_CATEGORY.SERIES]: {},
				[EVENT_CATEGORY.FESTIVAL]: {},
				[EVENT_CATEGORY.CHILDREN]: {},
				[EVENT_CATEGORY.PARTY]: {},
				[EVENT_CATEGORY.THEATER]: {},
				[EVENT_CATEGORY.CONCERT]: {},
				[EVENT_CATEGORY.BEER]: {},
			},
			'eventCategoryId',
			null,
		);
	}
}

export const eventCategoryEnumBase = new EventCategoryEnumBase();
